import { useSyncExternalStore } from 'react'

export interface RaiseTicketOptions {
  /**
   * Wave 4 hook: HR logging a ticket for someone. When the modal gets its "Raised for" picker,
   * this preselects the employee; the server already accepts `raisedFor`.
   */
  raisedFor?: string
}

/** Open state of the Raise a ticket modal (mounted once, next to the top-bar button). */
let state: RaiseTicketOptions | null = null
const listeners = new Set<() => void>()
const emit = () => {
  for (const l of listeners) l()
}

export function openRaiseTicket(options: RaiseTicketOptions = {}) {
  state = options
  emit()
}

export function closeRaiseTicket() {
  state = null
  emit()
}

export function useRaiseTicketState(): RaiseTicketOptions | null {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l)
      return () => listeners.delete(l)
    },
    () => state,
    () => null,
  )
}
